export interface MagentoSalesOrderItemValues {
  amount_refunded: number;
  base_amount_refunded: number;
  base_discount_amount: number;
  base_discount_invoiced: number;
  base_discount_tax_compensation_amount: number;
  base_original_price: number;
  base_price: number;
  base_price_incl_tax: number;
  base_row_invoiced: number;
  base_row_total: number;
  base_row_total_incl_tax: number;
  base_tax_amount: number;
  base_tax_invoiced: number;
  created_at: string;
  discount_amount: number;
  discount_invoiced: number;
  discount_percent: number;
  free_shipping: number;
  discount_tax_compensation_amount: number;
  is_qty_decimal: number;
  is_virtual: number;
  item_id: number;
  name: string;
  no_discount: number;
  order_id: number;
  original_price: number;
  price: number;
  price_incl_tax: number;
  product_id: number;
  product_type: string;
  qty_canceled: number;
  qty_invoiced: number;
  qty_ordered: number;
  qty_refunded: number;
  qty_shipped: number;
  quote_item_id: number;
  row_invoiced: number;
  row_total: number;
  row_total_incl_tax: number;
  row_weight: number;
  sku: string;
  store_id: number;
  tax_amount: number;
  tax_invoiced: number;
  tax_percent: number;
  updated_at: string;
}
